/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import ImageUploader from "../../utils/ImageUploader";
import { CropperWrapper } from "../../utils/CropperWrapper";

export const Sw05: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("KSIĘGA BAŚNI");
  const [text2, setText2] = useState<string>("Miłoszka");
  const [text3, setText3] = useState<string>("Wielkich wrażeń");
  const [text4, setText4] = useState<string>("Przy spełnianiu marzeń");
  const [text5, setText5] = useState<string>("Ciocia Wiola i Wujek Patryk");
  const text1BasicSize = 34;
  const text2BasicSize = 100;
  const text3BasicSize = 44;
  const text4BasicSize = 44;
  const text5BasicSize = 40;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const aspect = 1;
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 850; // Maximum width for text
  const imageSize = "386px"; // User uploaded image size
  const imageTopDistance = "104mm"; // distance from the uploaded image to top
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'ComicSans'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'ComicSans'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'ComicSans'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10));
  }, [text4]);

  useEffect(() => {
    setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10));
  }, [text5]);

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      // Function to crop the image and get the result
      const croppedImg = await getCroppedImg(image, croppedAreaPixels); // Replace with your image cropping logic
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
                onImageChange={(image) => setImage(image)}
                setStep={setStep}
              />
              {step === "crop" && (
                <p>
                  Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
                </p>
              )}
              <div style={{ }}>
                {step !== "crop" && (
                  <Button onClick={handleSave} disabled={isSaving}>
                    {isSaving ? "Zapisywanie..." : "Zapisz"}
                  </Button>
                )}
                {step === "crop" && (
                  <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
                )}
              </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Arial, GreatVibes",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        <div className="sw-01-text-wrapper" style={{}}>
          <InlineEdit
            value={text1}
            setValue={setText1}
            style={{
              fontSize: `${fontSizeText1}px`,
              lineHeight: `${fontSizeText1}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '111px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'Arial',
              color: "#010101",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />
          <InlineEdit
            value={text2}
            setValue={setText2}
            style={{
              fontSize: `${fontSizeText2}px`,
              lineHeight: `${fontSizeText2}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '183px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'GreatVibes',
              color: "rgba(47,106,79,90%)",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />
          <InlineEdit
            value={text3}
            setValue={setText3}
            style={{
              fontSize: `${fontSizeText3}px`,
              lineHeight: `${fontSizeText3}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '280px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'GreatVibes',
              color: "rgba(47,106,79,90%)",
              zIndex: "12",
              textAlign: "right",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          />

        <InlineEdit
            value={text4}
            setValue={setText4}
            style={{
              fontSize: `${fontSizeText4}px`,
              lineHeight: `${fontSizeText4}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '231px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'GreatVibes',
              color: "rgba(47,106,79,90%)",
              zIndex: "12",
              textAlign: "right",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          />

        <InlineEdit
            value={text5}
            setValue={setText5}
            style={{
              fontSize: `${fontSizeText5}px`,
              lineHeight: `${fontSizeText5}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '151px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'GreatVibes',
              color: "rgba(47,106,79,90%)",
              zIndex: "12",
              textAlign: "right",
              fontWeight: "400",
              letterSpacing: "0.0001em"
            }}
          />
                  </div>


        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            containerHeight={imageSize}
            containerWidth={imageSize}
            onCropComplete={handleCropComplete}
            cropShape="round"
            style={{
              top: imageTopDistance,
              left: "51%",
              width: imageSize,
              height: imageSize,
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            style={{
              position: "absolute",
              top: imageTopDistance,
              left: "51%",
              width: imageSize,
              height: imageSize,
              transform: "translateX(-50%)",
              borderRadius: "95% 90% 86% 83%",
              zIndex: 1,
            }}
          />
        )}

        {/* {!image && !croppedImage && (<img
          src="/images/sw05placeholder.png"
          style={{
            position: "absolute",
            zIndex: 1,
            top: "92mm",
              left: "51%",
              width: imageSize,
              height: imageSize,
              transform: "translateX(-50%)",
          }}
        />)} */}

        <img
          src="/images/Basnie SW05.png"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
